<router-outlet></router-outlet>
<!-- <rs-splash-screen></rs-splash-screen> -->
<rs-spinner></rs-spinner>
<notifier-container></notifier-container>
